export default __webpack_public_path__ + "static/media/customerIcon.e8b6f6c8.svg";